import script from "./positionPlaceholder.vue?vue&type=script&lang=js"
export * from "./positionPlaceholder.vue?vue&type=script&lang=js"

import "./positionPlaceholder.vue?vue&type=style&index=0&id=327732cc&lang=css"

const __exports__ = script;

export default __exports__